'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshWidgetDataAction = undefined;
exports.refreshWidgetData = refreshWidgetData;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var _resetStubbedThread = require('../../stubbed-thread-history/actions/resetStubbedThread');

var _stageInitialMessage = require('../../actions/PublishActions/stageInitialMessage');

var _isCreatingThread = require('../../threads/selectors/isCreatingThread');

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _removeClientTriggers = require('../../client-triggers/actions/removeClientTriggers');

var _bootstrapInitialWidgetUi = require('../../initial-message-bubble/actions/bootstrapInitialWidgetUi');

var refreshWidgetDataAction = exports.refreshWidgetDataAction = (0, _reduxActions.createAction)(_actionTypes.REFRESH_WIDGET_DATA, function (widgetData) {
  return widgetData;
});

function refreshWidgetData(widgetData) {
  return function (dispatch, getState) {
    dispatch(refreshWidgetDataAction(widgetData));

    var isStubbedThread = (0, _getSelectedThreadId.getSelectedThreadId)(getState()) === _stubbedThreadId.STUBBED_THREAD_ID;
    var isViewingStubbedThread = isStubbedThread && !(0, _isCreatingThread.isCreatingThread)(getState());

    if (isViewingStubbedThread) {
      dispatch((0, _resetStubbedThread.resetStubbedThread)());

      dispatch((0, _stageInitialMessage.stageInitialMessage)());
    }

    dispatch((0, _removeClientTriggers.removeClientTriggers)());
    dispatch((0, _bootstrapInitialWidgetUi.bootstrapInitialWidgetUi)(widgetData));
  };
}